import { getConciliationAmountLimit } from '../../../../../../utils/conciliationAmountLimit'
import { useContext, useEffect, useState } from 'react'
import TableMovVincular from './TableMovVincular'
import { BusinessAPI } from '../../../../../../../api/business.api'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import GlobalContext from '../../../../../../../context/global-context'
import TableVinCajaPrincipal from './TableVinCajaPrincipal'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'
import { BankAPI } from '../../../../../../../api/bancos.api'
import dayjs from 'dayjs'
import FilterDateConciliar from '../../../../../table/FilterDateConciliar'
import TablePagoAnticipo from './TablePagoAnticipo'
import { REACT_APP_RECONCILIATION_API_URL } from '../../../../../../utils/constant'

// Funcionalidad temporalmente oculta hasta completar su validación.
const ENABLE_PAGO_ANTICIPO_AGENTE_ADUANA = false

const InputField = ({ label, placeholder, type, value, onChange }) => (
  <div className='mt-1'>
    <label className='block mb-[1px] text-[11px] font-sans font-medium text-gray-700 leading-tight'>
      {label}
    </label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className=' h-7 block w-[150px] rounded-full border-gray-300 sm:text-[11px] font-sans font-medium'
    />
  </div>
)

const ListVincularArriendo = ({
  idLibro,
  onInitialSelectedIds,
  onCurrentSelectedIdsChange,
  dataModal,
  dataLinkage,
  reconciliationDetail,
  onCurrentDataBanco,
  onCurrentDataCaja,
  setSwitchGetData,
  selectedBank,
  setSelectedBank,
  modalStatus,
  selectedIds,
  setSelectedIds,
  useCajaPrincipal,
  unselectedIds,
  setUnselectedIds,
  origenSeleccionado,
  setOrigenSeleccionado,
  selectedCheckboxes,
  setSelectedCheckboxes,
  selectedDataByOrigen,
  setSelectedDataByOrigen,
  nombreOrigen,
  folioCredito,
  montoReferencia,
  onToggle
}) => {
  const businessAPI = new BusinessAPI()
  const organizationAPI = new OrganizationAPI()
  const { currentBusiness } = useContext(GlobalContext)
  const [data, setData] = useState([])
  const [searchKeyword, setSearchKeyword] = useState('')
  const [valoresAprox, setValoresAprox] = useState(false)
  const [value, setValue] = useState([null, null]) // inputs
  const [, setDebouncedValue] = useState([null, null])
  const [porcentajeRange] = useState([0, 100])
  const [showFilters, setShowFilters] = useState(true)
  const [, setMonthFilter] = useState(dayjs().format('MM'))
  const [, setYearFilter] = useState(dayjs().format('YYYY'))
  const [filters] = useState({
    fechaInicio: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaFin: dayjs().format('YYYY-MM-DD')
  })
  const [tempFilters, setTempFilters] = useState({ ...filters })
  const bankAPI = new BankAPI()
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [e2eConsumedIdLibros, setE2eConsumedIdLibros] = useState([])
  const [isLoadingE2EConsumed, setIsLoadingE2EConsumed] = useState(true)
  const [, setBancosUnicos] = useState([])
  const [dataBanco, setDataBanco] = useState({})
  const [page] = useState(0)
  const [rowsPerPage] = useState(-1)
  const [order, setOrder] = useState({ col: '',field: '', direction: 'asc' })
  const [isInitialSelectionDone, setIsInitialSelectionDone] = useState(false);
  const [dataPagoAnticipo, setDataPagoAnticipo] = useState([])
  const esAnticipoAgenteAduana =
    ENABLE_PAGO_ANTICIPO_AGENTE_ADUANA &&
    Number(folioCredito ?? dataModal?.folioCredito) === 27

  const toArr = v => (Array.isArray(v) ? v : [])
  const [, setForceShowAll] = useState(false)
  // FIFO de filas seleccionadas
  const [, setSelectionQueue] = useState([])

  // Acordeón: estado y helpers (ponlo cerca de otros useState)
  const [collapsed, setCollapsed] = useState({})

  // ¿está colapsada esta sección?
  const isCollapsed = key => Boolean(collapsed?.[key])

  // alternar colapso/expansión
  const toggleSection = key => {
  setCollapsed(prev => {
    const next = {}
    ;['banco', 'caja', 'anticipo'].forEach(k => {
      next[k] = k !== key
    })
    if (!prev[key]) {
      next[key] = true
    } else {
      next[key] = false
    }
    return next
  })
}
  // Derivados seguros
  const safeSelectedIds = toArr(selectedIds)
  const safeOrigen = toArr(origenSeleccionado)

  const getBanco = async () => {
    try {
      const responseBank = await bankAPI.getListBank(currentBusiness.id)
      setDataBanco(responseBank)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getBanco()
  }, [currentBusiness])

  const bankOptions = [
    'Caja Principal',
    ...(Array.isArray(dataBanco?.data)
      ? dataBanco.data
          .map(item => item.bank?.name)
          .filter(name => name && name !== 'Caja Principal')
          .filter((value, index, self) => self.indexOf(value) === index)
      : [])
  ]
  useEffect(() => {
      setSelectionQueue(prev => {
        const keep = prev.filter(id => safeSelectedIds.includes(id))
        const additions = safeSelectedIds.filter(id => !prev.includes(id))
        return [...keep, ...additions]
      })
    }, [selectedIds])

    const handleCheckboxChange = (tipo, ids) => {
      // ids siempre es array de números
      const idsArr = toArr(ids).filter(id => Number.isFinite(Number(id)))

      setSelectedIds(prev => ({
        ...prev,
        [tipo]: idsArr
      }))

      setSelectionQueue(prev => {
        const keep = prev.filter(id => idsArr.includes(id))
        const additions = idsArr.filter(id => !prev.includes(id))
        return [...keep, ...additions]
      })
  }

  const getData = async () => {
    try {
      if (!currentBusiness?.id || !idLibro) return

      const response = await organizationAPI.getListaParaVincular({
        businessId: currentBusiness.id,
        idLibro,
        from: tempFilters.fechaInicio,
        to: tempFilters.fechaFin,
        amountFrom: 1,
        amountTo: getConciliationAmountLimit(montoReferencia ?? dataModal?.montoTotal),
        limit: 10000
      })
      const rows = Array.isArray(response?.data?.libros) ? response.data.libros : []
      setData(rows)
      const bancos = Array.from(
        new Set(
          rows
            .map(item => item.nombreCuentaBanco?.trim())
            .filter(nombre => nombre && nombre.toLowerCase() !== 'caja principal')
        )
      )
      setBancosUnicos(['Caja Principal', ...bancos])
      setIsLoadingData(false)
    } catch (error) {
      console.error(error)
    } finally {
      //ui
    }
  }
  useEffect(() => {
    getData()
  }, [currentBusiness?.id, idLibro, tempFilters, montoReferencia, dataModal?.montoTotal])

  const getE2EConsumedMovements = async () => {
    if (
      !currentBusiness?.id ||
      !currentBusiness?.conciliacionAutomatica
    ) {
      setE2eConsumedIdLibros([])
      setIsLoadingE2EConsumed(false)
      return
    }

    try {
      setIsLoadingE2EConsumed(true)

      const response = await fetch(
        `${REACT_APP_RECONCILIATION_API_URL}/f29/conciliacion/bank-summary?businessId=${currentBusiness.id}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }
      )

      if (!response.ok) {
        throw new Error(
          `Error consultando bank-summary F29: ${response.status}`
        )
      }

      const responseData = await response.json()

      const consumedIds = (responseData?.items ?? [])
        .filter(item => item?.isReconciled === true)
        .map(item => Number(item?.idLibro))
        .filter(Number.isFinite)

      setE2eConsumedIdLibros([
        ...new Set(consumedIds)
      ])
    } catch (error) {
      console.error(
        'No fue posible obtener movimientos F29 E2E consumidos:',
        error
      )

      // Convivencia feliz:
      // si el servicio E2E falla, Luca conserva su comportamiento nativo.
      setE2eConsumedIdLibros([])
    } finally {
      setIsLoadingE2EConsumed(false)
    }
  }

  useEffect(() => {
    getE2EConsumedMovements()
  }, [
    currentBusiness?.id,
    currentBusiness?.conciliacionAutomatica
  ])

  useEffect(() => {
    if (!esAnticipoAgenteAduana || !currentBusiness?.id) {
      setDataPagoAnticipo([])
      return
    }

    let active = true
    const getProveedores = async () => {
      try {
        const response = await businessAPI.getListSummaryMovementsSpecific({
          businessId: currentBusiness.id,
          type: 'egreso',
          month: 0,
          year: Number(dayjs(tempFilters.fechaInicio).format('YYYY')),
          max: 30,
          page: 0,
          linkage: true,
          aprobadoMin: -5
        })
        const payload = response?.data
        const rows = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.rows)
              ? payload.rows
              : Array.isArray(payload?.content)
                ? payload.content
                : payload && typeof payload === 'object'
                  ? Object.values(payload).flat().filter(item => item && typeof item === 'object')
                  : []
        const documentosDin = rows.filter(
          row => row?.nombreFolio === 'Declaración de Ingreso (DIN)'
        )
        if (active) setDataPagoAnticipo(documentosDin)
      } catch (error) {
        console.error('[Pago Anticipo] Error al consultar documentos de proveedores', error)
        if (active) setDataPagoAnticipo([])
      }
    }

    getProveedores()
    return () => {
      active = false
    }
  }, [
    currentBusiness?.id,
    esAnticipoAgenteAduana,
    tempFilters.fechaInicio,
    tempFilters.fechaFin
  ])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, 500) // Espera 500ms después del último movimiento

    return () => {
      clearTimeout(handler)
    }
  }, [value])

  const resetSlider = () => {
    const defaultValue = [1, getConciliationAmountLimit(montoReferencia ?? dataModal?.montoTotal)]
    setValue(defaultValue)
    setDebouncedValue(defaultValue)
  }

  const handleDateChange = (key, newValue) => {
    const newDate = dayjs(newValue)
    setTempFilters(prev => ({
      ...prev,
      [key]: newDate.format('YYYY-MM-DD')
    }))
    if (key === 'fechaInicio') {
      setMonthFilter(newDate.format('MM'))
      setYearFilter(newDate.format('YYYY'))
    }
  }

  const handleSort = ({ col, field }) => {
    const isAsc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: isAsc ? 'desc' : 'asc' })
  }

  const e2eF29IdLibros = Array.isArray(reconciliationDetail?.movements)
    ? reconciliationDetail.movements
        .map(movement => movement?.idLibro)
        .filter(id => id != null)
    : []
  
  const currentE2EIdLibroSet = new Set(
    e2eF29IdLibros
      .map(Number)
      .filter(Number.isFinite)
  )

  const consumedE2EIdLibroSet = new Set(
    e2eConsumedIdLibros
      .map(Number)
      .filter(Number.isFinite)
  )

  const nativeLinkage = Array.isArray(dataLinkage)
    ? dataLinkage
    : []

  const nativeLinkageIds = new Set(
    nativeLinkage
      .map(item => item?.idPrincipal ?? item?.id)
      .filter(id => id != null)
      .map(String)
  )

  const e2eF29Linkage = Array.isArray(reconciliationDetail?.movements)
    ? reconciliationDetail.movements
        .filter(
          movement =>
            movement?.idLibro != null &&
            !nativeLinkageIds.has(String(movement.idLibro))
        )
        .map(movement => ({
          idPrincipal: movement.idLibro,
          fecha: movement.date,
          descripcion: movement.description,
          amount:
            movement.side === 'cargo'
              ? -Math.abs(Number(movement.amount) || 0)
              : Math.abs(Number(movement.amount) || 0),
          tipoMovimiento: movement.side,
          __e2eF29: true
        }))
    : []

  const effectiveLinkage = [
    ...nativeLinkage,
    ...e2eF29Linkage
  ]

  const linkageIdPrincipales = effectiveLinkage
    .map(item => item?.idPrincipal ?? item?.id)
    .filter(id => id != null)

  const isFullyConciliated = modalStatus === 'COBRADO' || modalStatus === 'PAGADO'
  const isPartialConciliation =
    modalStatus === 'PARCIALMENTE COBRADO' || modalStatus === 'PARCIALMENTE PAGADO'
  const isPendingStatus = modalStatus === 'POR COBRAR' || modalStatus === 'POR PAGAR'

  // Los movimientos disponibles pueden venir como PENDIENTE o PARCIALMENTE
  // CONCILIADO. Se conservan los estados de documentos por compatibilidad con
  // respuestas antiguas del endpoint.
  const validStatuses = [
    'pendiente',
    'parcialmente conciliado',
    'por cobrar',
    'por pagar'
  ]

  const total = Math.abs(Number(
    montoReferencia ??
      (nombreOrigen === 'sii' ? dataModal?.montoNeto : dataModal?.montoTotal)
  )) || 1

  const calcPorcentaje = (monto, total) => {
    const montoNum = Math.abs(Number(monto))
    if (isNaN(montoNum) || total === 0) return 0
    const diff = Math.abs(montoNum - total)
    const pct = (1 - diff / total) * 100
    return Math.max(pct, 0)
  }

  const getRowAmount = row => {
    if (Number(row?.tabla) === 46) return -Math.abs(Number(row?.monto) || 0)
    if (row?.amount != null && Number.isFinite(Number(row.amount))) return Number(row.amount)
    return row?.tipoMovimiento === 'cargo'
      ? -Math.abs(Number(row?.montoCargo) || 0)
      : Number(row?.montoAbono) || 0
  }

  const enrichAndFilter = rows => {
    const monto = getRowAmount(rows)
    const porcentaje = calcPorcentaje(monto, total)
    return {
      ...rows,
      porcentaje
    }
  }

  const applyFilters = rows => {
    const filteredRows = rows
      .map(enrichAndFilter)
      .filter(item => {
        const matchesKeyword = item.descripcion?.toLowerCase().includes(searchKeyword.toLowerCase())

        const matchesBank = selectedBank
          ? item.nombreCuentaBanco?.trim().toLowerCase() === selectedBank.toLowerCase()
          : true

        const matchesPorcentaje =
          item.porcentaje >= porcentajeRange[0] && item.porcentaje <= porcentajeRange[1]

        const itemDate = dayjs(item.fecha).format('YYYY-MM-DD')
        const matchesDate =
          (!tempFilters.fechaInicio || itemDate >= tempFilters.fechaInicio) &&
          (!tempFilters.fechaFin || itemDate <= tempFilters.fechaFin)

        return matchesKeyword && matchesBank && matchesPorcentaje && matchesDate
      })

    return valoresAprox
      ? [...filteredRows].sort((a, b) => b.porcentaje - a.porcentaje)
      : filteredRows
  }

  let filteredRows = []
  const toKeyString = row => {
    const key = row?.idPrincipal ?? row?.id
    return key != null ? String(key) : null
  }
  const linkageKeySet = new Set(
    linkageIdPrincipales.filter(id => id != null).map(id => String(id))
  )
  const isLinkedRow = item => {
    const key = toKeyString(item)
    return key != null && linkageKeySet.has(key)
  }
  const matchesValidStatus = item => {
    const statusValue = String(item?.status ?? '').trim().toLowerCase()
    return validStatuses.some(s => statusValue.includes(s))
  }
  const availableRows = (data || []).filter(row => {
    const rowId = Number(
      row?.idPrincipal ??
      row?.id
    )

    if (!Number.isFinite(rowId)) {
      return true
    }

    // El movimiento pertenece al F29 E2E
    // actualmente abierto: debe seguir visible.
    if (currentE2EIdLibroSet.has(rowId)) {
      return true
    }

    // Si otra conciliación F29 E2E ya lo consume,
    // no debe aparecer como candidato en este modal.
    return !consumedE2EIdLibroSet.has(rowId)
  })

  const allFilteredRows = applyFilters(availableRows)

  // NUEVA CONDICION: si no hay vinculados (linkage vacío o no existe) mostrar toda la data sin filtro
  if (!linkageIdPrincipales.length) {
    filteredRows = allFilteredRows
  } else if (isFullyConciliated || isPartialConciliation || isPendingStatus) {
    filteredRows = allFilteredRows.filter(item => isLinkedRow(item) || matchesValidStatus(item))
  } else {
    filteredRows = allFilteredRows
  }

  const linkedRows = filteredRows.filter(isLinkedRow)
  const pendingRows = filteredRows.filter(item => !isLinkedRow(item))
  filteredRows = [...linkedRows, ...pendingRows]

  filteredRows = filteredRows.map(row => ({
    ...row,
    seleccionado: isLinkedRow(row)
  }))

  const getSortValue = (row, field) => {
    if (field === 'fecha') return dayjs(row?.fecha ?? row?.fechaPago).valueOf()
    if (field === 'cuentaCorriente') {
      return `${row?.nombreCuentaBanco ?? row?.name ?? ''} ${row?.numeroCuentaBanco ?? ''}`
    }
    if (field === 'descripcion') return row?.descripcion ?? ''
    if (field === 'abono') return Math.max(getRowAmount(row), 0)
    if (field === 'cargo') return Math.abs(Math.min(getRowAmount(row), 0))
    if (field === 'status') return String(row?.status ?? '')
    return row?.[field] ?? ''
  }

  const sortedRows = order.field
    ? filteredRows
        .map((row, index) => ({ row, index }))
        .sort((a, b) => {
          const valueA = getSortValue(a.row, order.field)
          const valueB = getSortValue(b.row, order.field)
          const comparison =
            typeof valueA === 'number' && typeof valueB === 'number'
              ? valueA - valueB
              : String(valueA).localeCompare(String(valueB), 'es', {
                  numeric: true,
                  sensitivity: 'base'
                })
          return (comparison || a.index - b.index) * (order.direction === 'asc' ? 1 : -1)
        })
        .map(({ row }) => row)
    : filteredRows

  const labelTexto = ['COBRADO', 'POR COBRAR', 'PARCIALMENTE COBRADO'].includes(modalStatus)
    ? 'Cobro con Caja Principal'
    : ['PAGADO', 'POR PAGAR', 'PARCIALMENTE PAGADO'].includes(modalStatus)
      ? 'Pago con Caja Principal'
      : ''

  const paginatedData =
    rowsPerPage > 0
      ? sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : sortedRows

  const opciones = [
    { value: 'caja', label: labelTexto },
    { value: 'banco', label: 'Pago con Bancos' },
    ...(esAnticipoAgenteAduana
      ? [{ value: 'anticipo', label: 'Pago Anticipo' }]
      : [])
  ]

  const isSelectedView = val => safeOrigen.includes(val)

  const orderedSections = []
  safeOrigen.forEach(v => {
    if (v === 'banco') orderedSections.push('banco')
    else if (v === 'caja') orderedSections.push('caja')
    else if (v === 'anticipo') orderedSections.push('anticipo')
  })

  const getSectionSelectedCount = (key) => {
    if (key === 'banco') {
      const selected = toArr(selectedDataByOrigen?.banco)
      const filtered = selected.filter(it => it?.nombreCuentaBanco !== "Caja Principal")
      return filtered.length
    }
    if (key === 'caja') {
      return toArr(selectedDataByOrigen?.caja).length
    }
    if (key === 'anticipo') {
      return toArr(selectedDataByOrigen?.anticipo).length
    }
    return 0
  }

  const renderSection = key => {
    const baseTitle =
      key === 'banco'
        ? 'Movimientos Bancarios'
        : key === 'caja'
          ? 'Movimientos de Caja'
          : key === 'anticipo'
            ? 'Documentos de Proveedores'
            : ''

    const selectedCount = getSectionSelectedCount(key)
    const headerTitle = selectedCount > 0 ? `${baseTitle} (${selectedCount})` : baseTitle

    if (key === 'banco' && !isSelectedView('banco')) return null
    if (key === 'caja' && !isSelectedView('caja')) return null
    if (key === 'anticipo' && !isSelectedView('anticipo')) return null

    return (
      <div key={`sec-${key}`} className='border border-gray-200 rounded-3xl bg-gray-100'>
        <button
          type='button'
          onClick={() => toggleSection(key)}
          className='w-full flex items-center justify-between px-3 py-2'
          aria-expanded={!isCollapsed(key)}
          aria-controls={`sec-panel-${key}`}
        >
          <span className='text-sm font-sans font-medium'>{headerTitle}</span>
          <KeyboardArrowDownIcon
            className={clsx('transition-transform', { 'rotate-180': !isCollapsed(key) })}
          />
        </button>

        {/* Contenido colapsable */}
        <div
          id={`sec-panel-${key}`}
          className={clsx(
            'transition-[max-height] duration-300 ease-in-out overflow-hidden',
            isCollapsed(key) ? 'max-h-0' : 'flex-1 h-full'
          )}
        >
          <div className='p-3 pt-0'>
            {key === 'banco' && (
              <TableMovVincular
                onCheckboxChange={handleCheckboxChange}
                rows={paginatedData}
                selectedBankFilter={selectedBank}
                dataModal={dataModal}
                dataLinkage={effectiveLinkage}
                serverLinkage={dataLinkage}
                onCurrentData={onCurrentDataBanco}
                onInitialSelectedIds={onInitialSelectedIds}
                onCurrentSelectedIdsChange={onCurrentSelectedIdsChange}
                onSort={handleSort}
                order={order}
                modalStatus={modalStatus}
                resetSlider={resetSlider}
                selectedIds={selectedIds.banco}
                setSelectedIds={ids => setSelectedIds(prev => ({ ...prev, banco: ids }))}
                unselectedIds={unselectedIds.banco}
                setUnselectedIds={updater => {
                  setUnselectedIds(prev => ({
                    ...prev,
                    banco: typeof updater === 'function' ? updater(prev.banco) : updater
                  }))
                }}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                setForceShowAll={setForceShowAll}
              />
            )}

            {key === 'caja' && (
              <TableVinCajaPrincipal
                onCheckboxChange={handleCheckboxChange}
                rows={filteredRows}
                selectedBankFilter={selectedBank}
                dataModal={dataModal}
                modalStatus={modalStatus}
                dataLinkage={dataLinkage}
                useCajaPrincipal={true}
                onCurrentData={onCurrentDataCaja}
                selectedIds={selectedIds.caja}
                setSelectedIds={ids => setSelectedIds(prev => ({ ...prev, caja: ids }))}
                unselectedIds={unselectedIds.caja}
                setUnselectedIds={updater => {
                  setUnselectedIds(prev => ({
                    ...prev,
                    caja: typeof updater === 'function' ? updater(prev.caja) : updater
                  }))
                }}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                selectedDataByOrigen={selectedDataByOrigen}
                setSelectedDataByOrigen={setSelectedDataByOrigen}
                onToggle={onToggle}
              />
            )}

            {key === 'anticipo' && (
              <TablePagoAnticipo
                rows={dataPagoAnticipo}
                modalStatus={modalStatus}
                selectedIds={selectedIds.anticipo ?? []}
                onSelectionChange={(ids, rows) => {
                  setSelectedIds(prev => ({ ...prev, anticipo: ids }))
                  setSelectedDataByOrigen(prev => ({
                    ...prev,
                    anticipo: rows.map(item => ({ ...item, _origen: 'anticipo' }))
                  }))
                }}
              />
            )}

          </div>
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (isInitialSelectionDone) return

    const nativeLinkage = Array.isArray(dataLinkage)
      ? dataLinkage
      : []

    const hasCajaPrincipal = nativeLinkage.some(
      item => item?.nombreCuentaBanco === 'Caja Principal'
    )

    const hasBanco =
      e2eF29IdLibros.length > 0 ||
      nativeLinkage.some(
        item => item?.nombreCuentaBanco !== 'Caja Principal'
      )

    const origenes = []

    if (hasCajaPrincipal) origenes.push('caja')
    if (hasBanco) origenes.push('banco')
    if (origenes.length === 0) origenes.push('banco')

    setOrigenSeleccionado(origenes)
    setIsInitialSelectionDone(true)
  }, [
    dataLinkage,
    e2eF29IdLibros.length,
    isInitialSelectionDone,
    setOrigenSeleccionado
  ])

  useEffect(() => {
    if (safeOrigen.length === 0) return
    const ultimo = safeOrigen[safeOrigen.length - 1]
    const mapKey = origen => {
      if (origen === 'banco') return 'banco'
      if (origen === 'caja') return 'caja'
      if (origen === 'anticipo') return 'anticipo'
      return null
    }
    const ultimaKey = mapKey(ultimo)
    if (!ultimaKey) return
    setCollapsed(prev => {
      const next = { ...prev }
      ;['banco', 'caja', 'anticipo'].forEach(k => {
        next[k] = k !== ultimaKey // true = colapsado
      })
      return next
    })
  }, [safeOrigen])

  return (
    <div className="h-full p-3 bg-white rounded-3xl shadow-md flex flex-col overflow-hidden">
     {isLoadingData || isLoadingE2EConsumed ? (
        <div className='flex items-center justify-center h-64'>
          <Lottie animationData={LoaderAdm} loop style={{ width: 200, height: 200 }} />
        </div>
      ) : (
      <>
      <div className='border border-gray-200 rounded-3xl p-4 bg-gray-50'>
        <div className='flex flex-wrap gap-x-2 gap-y-4 items-start'>
          <div className='flex flex-wrap gap-x-2 gap-y-4 items-start flex-1'>
            <div className='min-w-[150px] flex flex-col justify-end mt-5 font-sans font-medium'>
            <FilterDateConciliar
              label='Fecha Desde'
              value={tempFilters.fechaInicio}
              onChange={newValue => handleDateChange('fechaInicio', newValue)}
            />
          </div>
          <div className='min-w-[150px] flex flex-col justify-end mt-5 font-sans font-medium'>
            <FilterDateConciliar
              label='Fecha Hasta'
              value={tempFilters.fechaFin}
              onChange={newValue => handleDateChange('fechaFin', newValue)}
            />
          </div>
          <div className='min-w-[150px] font-sans font-medium'>
            <InputField
              label='Palabra Clave'
              type='text'
              value={searchKeyword}
              onChange={e => setSearchKeyword(e.target.value)}
            />
          </div>
          <div className='min-w-[150px]'>
            <label className='block mb-[1px] mt-1 text-[11px] font-sans font-medium text-gray-700 leading-tight'>
              Bancos
            </label>
            <select
              className='h-7 w-full appearance-none focus:outline-none border border-gray-300 px-4 py-[3px] rounded-full leading-tight font-medium text-[11px]'
              onChange={e => setSelectedBank(e.target.value)}
              value={selectedBank}
            >
              <option value=''>Todos</option>
              {bankOptions
                .filter(bankName => bankName !== 'Caja Principal')
                .map(bankName => (
                  <option key={bankName} value={bankName}>
                    {bankName}
                  </option>
                ))}
            </select>
          </div>
          <label className='mt-5 inline-flex h-7 cursor-pointer items-center gap-2 text-[11px] font-sans font-medium'>
            <input
              type='checkbox'
              checked={valoresAprox}
              onChange={e => setValoresAprox(e.target.checked)}
              className='rounded'
            />
            Monto Similares
          </label>
          {/*<div className='min-w-[150px] flex flex-col'>
            <label className='text-[11px] font-medium text-gray-700 leading-tight'>
              Coincidencia porcentaje
            </label>
            <Slider
              value={porcentajeRange}
              onChange={(e, newValue) => setPorcentajeRange(newValue)}
              valueLabelDisplay='auto'
              valueLabelFormat={value => `${value}%`}
              min={0}
              max={100}
              sx={{
                height: 4,
                '& .MuiSlider-thumb': {
                  width: 14,
                  height: 14
                },
                '& .MuiSlider-track': {
                  height: 4
                },
                '& .MuiSlider-rail': {
                  height: 4
                },
                '& .MuiSlider-valueLabel': {
                  fontSize: '10px',
                  padding: '2px 4px'
                }
              }}
            />
            <div className='text-[11px] text-gray-600 mt-1'>
              {porcentajeRange[0]}% - {porcentajeRange[1]}%
            </div>
          </div>*/}
          {showFilters && (
          <div id='filters-panel' className='contents font-medium'>
           <div className='min-w-[200px]'>
            <label className='block mb-[1px] font-sans font-medium mt-1 text-[11px] font-small text-gray-700 leading-tight'>
                Tipo de Pago
              </label>
              <div className='grid grid-cols-2 gap-x-4 gap-y-2 px-3 py-2 text-[11px]'>
            {opciones.map(option => (
              <label key={option.value} className='flex items-center gap-2 font-sans font-medium'>
                <input
                  type='checkbox'
                  className='rounded'
                  value={option.value}
                  checked={origenSeleccionado.includes(option.value)}
                  onChange={e => {
                    const checked = e.target.checked
                    const origen = option.value
                    setOrigenSeleccionado(prev => {
                      const updated = checked
                        ? [...prev, origen]
                        : prev.filter(val => val !== origen)
                      return updated
                    })
                    if (!checked) {
                      const idsToRemove = (selectedDataByOrigen[origen] || []).map(r => r.id)
                      setUnselectedIds(prev => ({
                        ...prev,
                        [origen]: idsToRemove
                      }))
                      setSelectedDataByOrigen(prev => {
                        const next = { ...prev }
                        delete next[origen]
                        return next
                      })
                      setSelectedIds(prev => {
                        const next = { ...prev }
                        delete next[origen]
                        return next
                      })
                      setSelectedCheckboxes(prev => {
                        const next = { ...prev }
                        idsToRemove.forEach(id => delete next[id])
                        return next
                      })
                    } else {
                      setUnselectedIds(prev => {
                        const next = { ...prev }
                        delete next[origen]
                        return next
                      })
                    }
                  }}
                />
                {option.label}
                </label>
              ))}
            </div>
            </div>
            </div>
        )}
        </div>
        <div className='ml-auto mt-5'>
          <button
            type='button'
            className='flex items-center px-1 py-0.5 bg-gray-200 rounded hover:bg-gray-300 transition'
            onClick={() => setShowFilters(prev => !prev)}
            aria-expanded={showFilters}
            aria-controls='filters-panel'
          >
            <KeyboardArrowDownIcon
              className={clsx('transition-transform', { 'rotate-180': showFilters })}
            />
          </button>
        </div>
      </div>
       </div>
        <div className='flex-1 min-h-0 mt-3 overflow-y-auto overflow-x-hidden'>
          <div className='flex flex-col space-y-3 font-medium'>
            {orderedSections.map(secKey => renderSection(secKey))}
          </div>
        </div>
      </>
      )}
    </div>
  )
}

export default ListVincularArriendo
